import { CircleInfo } from "@/icons/CircleInfo.tsx";
import { Alert } from "@mantine/core";
import { memo } from "react";

export const Error = memo(function Error() {
  return (
    <Alert
      icon={<CircleInfo size={24} />}
      color="red"
      title="Something went wrong"
    >
      Please try again later.
    </Alert>
  );
});
